import { getLanguageDisplayName } from "./languageHelper";

export const getCountryCodeFromLanguage = (locale) => {
    // Handle null/undefined/non-string inputs
    if (!locale || typeof locale !== "string") {
        return null;
    }

    // Handle different format patterns: en-US, en_US, or just US
    const parts = locale.includes("-")
        ? locale.split("-")
        : (locale.includes("_") ? locale.split("_") : [null, locale]);

    // Ensure we have a second part for the country code
    if (parts.length < 2 || !parts[1]) {
        return null;
    }

    // Return uppercase country code
    return parts[1].toUpperCase();
};

export const getLanguageName = (locale) => {
    if (typeof locale !== "string" || !locale.includes("-")) {
      return null;
    }
    const languageCode = locale.split("-")[0].toLowerCase();
    return getLanguageDisplayName(languageCode);
  };